const OGWSelector = (() => {
  const products = {stageone:'offgrid-stageone', domesticBundle:'stageone-stagetwo-bundle', canalBundle:'stageone-stagetwo-bundle-ro-combo', canalComplete:'stageone-v3-0-stagetwo-bundle-led-uvc-ro-combo-july-pre-order', rain:'offgrid-rain-1', rainBundle:'offgrid-rain-v2-0-finalstage-bundle', ro:'offgrid-reverseosmosis', roStageTwo:'offgrid-stagetwo', stagetwo:'offgrid-stagetwo'};
  function recommend(a) {
    if (!['canal','rain','tank','mains','treated','ground','saline','other'].includes(a.source) || !['domestic','drink','both'].includes(a.use)) return {reason:'incomplete', keys:[]};
    if (a.source === 'saline') return {reason:'saline', keys:[], unsupported:true};
    if (a.source === 'ground') return {reason:'test', keys:[]};
    if (a.source === 'other') return {reason:'other', keys:[]};
    if (!['standard','high','unsure'].includes(a.demand)) return {reason:'incomplete', keys:[]};
    if (a.demand === 'high') return {reason:'capacity', keys:[]};
    const check=a.demand==='unsure';
    if (a.source === 'canal') return {keys:a.use==='domestic'?['domesticBundle','stageone']:['canalComplete','canalBundle'], reason:a.use==='domestic'?'stageone':a.use==='drink'?'rawCanal':'canalBundle', check};
    if (a.source === 'rain') return {keys:[a.use==='domestic'?'rain':'rainBundle'], reason:a.use==='domestic'?'rain':a.use==='drink'?'rawRain':'rainBundle', check};
    if (a.use==='domestic') return {keys:['stagetwo'], reason:'stagetwo', check};
    return {keys:a.source==='tank'?['roStageTwo','ro']:['ro','roStageTwo'], reason:a.source==='tank'?'tank':'ro', check};
  }
  return {products,recommend};
})();
if (typeof module !== 'undefined' && module.exports) module.exports = OGWSelector;
if (typeof customElements !== 'undefined' && !customElements.get('ogw-system-selector')) {
  customElements.define('ogw-system-selector', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller=new AbortController();
      const signal=this.controller.signal;
      this.copy=JSON.parse(this.querySelector('[data-selector-copy]').textContent);
      this.steps=Array.from(this.querySelectorAll('fieldset'));
      this.result=this.querySelector('[data-result]');
      this.step=0;
      this.addEventListener('change',()=>{this.querySelector('[data-error]').hidden=true;this.updateProgress();},{signal});
      this.querySelector('[data-next]').addEventListener('click',()=>{
        if (!this.steps[this.step].querySelector('input:checked')) {this.querySelector('[data-error]').hidden=false;return;}
        if (this.step===this.activeStepCount()-1) this.showResult();
        else {this.step++;this.showStep();}
      },{signal});
      this.querySelector('[data-back]').addEventListener('click',()=>{this.step=Math.max(0,this.step-1);this.showStep();},{signal});
      this.querySelector('[data-restart]').addEventListener('click',()=>{this.step=0;this.showStep();},{signal});
      this.querySelector('[data-reset]').addEventListener('click',()=>{this.querySelectorAll('input').forEach(i=>i.checked=false);this.step=0;this.showStep();},{signal});
      this.setAttribute('data-ready','');this.showStep(false);
    }
    answers(){return Object.fromEntries(Array.from(this.querySelectorAll('input:checked')).map(i=>[i.name,i.value]));}
    activeStepCount(){return ['saline','ground','other'].includes(this.answers().source)?2:3;}
    updateProgress(){
      const total=this.activeStepCount();
      this.querySelector('[data-progress]').textContent=this.copy.step.replace('{n}',this.step+1).replace('{total}',total);
      const progress=this.querySelector('progress');progress.max=total;progress.value=this.step+1;
      this.querySelector('[data-next]').textContent=this.step===total-1?this.copy.show:this.copy.next;
    }
    showStep(focus=true){
      this.result.hidden=true;this.querySelector('[data-questions]').hidden=false;
      this.steps.forEach((s,i)=>s.hidden=i!==this.step);
      this.querySelector('[data-error]').hidden=true;
      this.querySelector('[data-back]').hidden=this.step===0;
      this.querySelector('[data-source-legend]').textContent=this.answers().use==='drink'?this.copy.drinkSource:this.copy.source;
      this.updateProgress();
      if(focus)this.steps[this.step].querySelector('legend').focus();
    }
    showResult(){
      const a=this.answers(),r=OGWSelector.recommend(a);
      if(r.reason==='incomplete')return;
      this.querySelector('[data-questions]').hidden=true;this.result.hidden=false;
      this.querySelector('[data-result-title]').textContent=r.unsupported?this.copy.unsupported:r.keys.length?this.copy.recommendation:this.copy.specialist;
      this.querySelector('[data-reason]').textContent=this.copy[r.reason];
      let found=0;
      this.querySelectorAll('[data-product-result]').forEach(card=>{
        const order=r.keys.indexOf(card.dataset.productResult);card.hidden=order===-1;card.style.order=order;
        if(order!==-1)found++;
      });
      r.keys.forEach(key=>{const card=this.querySelector('[data-product-result="'+key+'"]');if(card)card.parentNode.appendChild(card);});
      this.querySelector('[data-install-stage]').hidden=!r.keys.some(k=>['domesticBundle','canalComplete','canalBundle','roStageTwo','stagetwo'].includes(k));
      this.querySelector('[data-install-ro]').hidden=!r.keys.some(k=>['canalComplete','canalBundle','rainBundle','roStageTwo','ro'].includes(k));
      this.querySelector('[data-install-flow]').hidden=this.querySelector('[data-install-stage]').hidden;
      this.querySelector('[data-missing]').hidden=found===r.keys.length;
      this.querySelector('[data-capacity-note]').hidden=!r.check;
      this.querySelector('[data-contact-result]').hidden=!!r.unsupported||(!!r.keys.length&&found===r.keys.length);
      this.querySelector('[data-compatibility]').hidden=!r.keys.length;
      this.querySelector('[data-installation]').hidden=!r.keys.some(k=>!['stageone','rain'].includes(k));
      this.querySelector('[data-uv-comparison]').hidden=!r.keys.includes('canalComplete');
      this.querySelector('[data-ro-condition]').hidden=!r.keys.includes('ro');
      const inputs=Array.from(this.querySelectorAll('input:checked')).filter(i=>this.activeStepCount()===3||i.name!=='demand');
      const summary=inputs.map(i=>i.dataset.summary).join(' · ');
      this.querySelector('[data-answer-summary]').textContent=summary;
      this.querySelectorAll('[data-contact-link]').forEach(link=>{link.hidden=!!r.unsupported;link.href='/pages/contact?setup='+encodeURIComponent(summary+'\n'+this.copy[r.reason])+'#ogw-contact-form';});
      this.querySelector('[data-result-title]').focus();
    }
    disconnectedCallback(){this.controller?.abort();this.controller=null;}
  });
}
